import { format, parseISO } from 'date-fns';
import { type ReactElement } from 'react';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import sv from '../../Util/customDateFnsSwedish';
import formatCloseRelative from '../../Util/formatCloseRelative';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type WeatherMeasurepointProperties } from '../Sources/WeatherMeasurepoint';
import PopupTemplateWrapper from './PopupTemplateWrapper';

function formatNumber(value: number | undefined | null): string {
    if (!value) {
        return '';
    }

    return value.toLocaleString('sv-SE', { maximumFractionDigits: 1 });
}

export default function WeatherMeasurepoint(properties: WeatherMeasurepointProperties, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    return (
        <PopupTemplateWrapper iconId={properties.iconId} title={layerOptions.name}>
            <div>
                <h3>{properties.name}</h3>
                <table>
                    <tbody>
                        {!properties.isValid && (
                            <tr>
                                <td>Aktuell data saknas</td>
                            </tr>
                        )}
                        {properties.isValid && (
                            <>
                                {properties.precipitationType && (
                                    <tr>
                                        <td className="bold">Nederbörd:</td>
                                        <td>{properties.precipitationType}</td>
                                    </tr>
                                )}

                                {properties.windSpeedAverage != null && (
                                    <tr>
                                        <td className="bold">Vindstyrka (byvind):</td>
                                        <td>
                                            {formatNumber(properties.windSpeedAverage)} ({formatNumber(properties.windSpeedMax)}) m/s
                                        </td>
                                    </tr>
                                )}
                                {properties.windDirection != null && (
                                    <tr>
                                        <td className="bold">Vindriktning:</td>
                                        <td>{properties.windDirection}</td>
                                    </tr>
                                )}
                                {properties.airTemp != null && (
                                    <tr>
                                        <td className="bold">Temperatur luft:</td>
                                        <td>{formatNumber(properties.airTemp)} &#176;C</td>
                                    </tr>
                                )}
                                {properties.roadTemp != null && (
                                    <tr>
                                        <td className="bold">Temperatur vägyta:</td>
                                        <td>{formatNumber(properties.roadTemp)} &#176;C</td>
                                    </tr>
                                )}
                                {properties.moisture != null && (
                                    <tr>
                                        <td className="bold">Luftfuktighet:</td>
                                        <td>{formatNumber(properties.moisture)} %</td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
                {properties.isValid && (
                    <dl className="popup-details">
                        <dt>Uppmätt:</dt>
                        <dd title={properties.measureat && format(parseISO(properties.measureat), 'Pp', { locale: sv })}>
                            {properties.measureat ? (
                                <TimeElement date={parseISO(properties.measureat)}>
                                    {capitalizeFirstLetter(formatCloseRelative(parseISO(properties.measureat)))}
                                </TimeElement>
                            ) : (
                                'Ingen uppgift'
                            )}
                        </dd>
                        <dt>Källa:</dt>
                        <dd>Trafikverket</dd>
                    </dl>
                )}
            </div>
        </PopupTemplateWrapper>
    );
}
